import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import { debounceTime, distinctUntilChanged, from, of, switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
// import { json } from 'd3';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounce } from 'lodash';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-device-type-listing',
  templateUrl: './device-type-listing.component.html',
  styleUrls: ['./device-type-listing.component.scss'],
  standalone:true,
  imports:[CommonModule,MatMenu,MatMenuModule,MatButtonModule,MatIconModule,ReactiveFormsModule,MatFormFieldModule, MatInputModule]
})
export class DeviceTypeListingComponent implements OnInit {
  private deviceTypeListingUrl = BaseUrlConstantsService.DEVICE_TYPE_LIST;
  private deviceDeleteUrl = BaseUrlConstantsService.DELETE_DEVICE;
  private addDeviceType: any = BaseUrlConstantsService.ADD_DEVICE_TYPE;
  private editDeviceType: any = BaseUrlConstantsService.EDIT_DEVICETYPE_INFO;
  private deviceTypeListingFromMacUrl: any = BaseUrlConstantsService.BASE_INVENTORY_URL;
  public uploader: FileUploader;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public arrayList: any;
  public pageRouteRef: string;
  public deviceArrayList: any = [];
  public deviceTypeList: any = [];
  public showEmptyError = '';
  public today: Date;
  public breadcrumbsArray: any = [{
    page_ref: 'view-device-type',
    page_title: 'device type'
  }];
  public percentDone: any;
  public deviceTypeID: any;
  public mac_address = new FormControl('');
  private select_mac_device_id='';
  filterDeviceArrayList=[];

  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    public dialog: MatDialog,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute) {
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.CSV_IMPORT_INVENTORY, itemAlias: 'photo' });
    this.utcTime();
    this.arrayList = [{
      device_type: 'AC Brushless Motors',
    }];
  }

  searchData(ev) {
    const term = ev.toLowerCase();
    this.deviceTypeList = this.deviceArrayList.filter(result => result.name.toLowerCase().indexOf(term) >= 0);
    if (this.deviceTypeList.length === 0) {
      this.showEmptyError = 'No Results';
    } else {
      this.showEmptyError = '';
    }
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit() {
    let self = this;
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', localStorage.getItem('user_id'));
      form.append('device_id', this.deviceTypeID);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (JSON.parse(response).data.status === 'error') {
        self.service.showError(JSON.parse(response).data.message);
      } else {
        self.service.showSuccess(JSON.parse(response).data.message)
        this.getDeviceTypeListing();
      }
    };
    this.pageRouteRef = 'view-device-type';
    this.getDeviceTypeListing();

    this.mac_address.valueChanges.pipe(debounceTime(300),distinctUntilChanged(),switchMap(value=>{
      this.filterDeviceArrayList=[];
      console.log(`${this.deviceTypeListingFromMacUrl}inventory/v2/get_type_by_mac/${value}`)
      // this.service.getDataV2('http://localhost:3500/inventory/v2/get_type_by_mac/'+value).then(res=>{
      this.service.getDataV2(`${this.deviceTypeListingFromMacUrl}inventory/v2/get_type_by_mac/${value}`).then(res=>{
        const response:any=res;
        console.log(response)
        console.log(response.code)
        if(response.data.code==200 && response.data.status=='success'){
          console.log("Surya")
          console.log(response.data.body)
          this.select_mac_device_id=response.data.body.id;
          this.filterDeviceArrayList=this.deviceArrayList.filter(type=>type.id==this.select_mac_device_id);
          console.log(this.filterDeviceArrayList)
        }

      })
      return of(null);
    })).subscribe()
  }


  upload(files: any, device_id) {
      this.deviceTypeID = device_id;
      this.uploader.uploadAll();
      this.uploader.onProgressItem = (progress: any) => {
        this.percentDone = progress['progress'];
      };
  }
getDeviceTypeListing() {
  if(localStorage.getItem("role") =="ADMIN"){
    this.changeService.loader(true);
    this.service.getData(this.deviceTypeListingUrl + "/" + localStorage.getItem('user_id')).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.deviceArrayList = JSON.parse(JSON.stringify(res)).data.body;
        this.deviceTypeList = this.deviceArrayList;
        if (this.deviceArrayList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        }
        else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  }

  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteDevice(id, index);
      }
    });
  }

  deleteDevice(id, index) {
    this.service.deleteInfo(this.deviceDeleteUrl + "/" + id).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
        this.service.showSuccess('Successfully deleted.');
        this.deviceTypeList.splice(index, 1);
        if (this.deviceTypeList.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }


  viewInventories(typeId, name, subName,deviceCategoryId,device) {
    console.log(device)
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceName: name,
        deviceDetail: subName,
        deviceCategory:deviceCategoryId,
        is_piezo_gateway:device.is_piezo_gateway
      }
    };
    this.router.navigate(['devices'], navigationExtras);
  }
  viewInventoriesFilteredClick(typeId, name, subName,deviceCategoryId) {
    console.log(this.mac_address)
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceName: name,
        deviceDetail: subName,
        deviceCategory:deviceCategoryId,
        mac:this.mac_address.value
      }
    };
    this.router.navigate(['devices'], navigationExtras);
  }



  trackByFn(index, item) {
    return item.id;
  }

  showInventory(typeId, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceName: name
      }
    };
    this.router.navigate(['devices'], navigationExtras);
  }

  async addDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        lastPageRef: 'view-device-type'

      }
    };
    this.router.navigate(['add-device-type'], navigationExtras);
  }

  addNewDevice() {
    this.viewNewDeviceDialogBox();
  }


  viewNewDeviceDialogBox() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'addNewDeviceDailogBox',
        data: { device_type: "", device_detail: "",device_category_id: "", communication_type:"",config_mapping: "no", device_start_number: "",number_of_connection: "" }
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result !== undefined) {
        if (result.type === 'addNewDeviceDailogBox') {
          if (result.device_type === undefined) {
            this.service.showError("Device type can't be empty.");
          } else if (result.device_detail === undefined) {
            this.service.showError("Device detail can't be empty.");
          } else {
            let body = {};
            if(result.device_category_id==2|| result.device_category_id==3){

              body = {
                user_id: localStorage.getItem('user_id'),
                name: result.device_type,
                detail: result.device_detail,
                communication_type: result.communication_type,
                device_category_id: result.device_category_id,
                config_mapping: result.config_mapping,
                device_start_number: result.device_start_number,
                number_of_connection: result.number_of_connection
              };

            }else if(result.device_category_id==5){
              body = {
                user_id: localStorage.getItem('user_id'),
                name: result.device_type,
                detail: result.device_detail,
                communication_type: result.communication_type,
                device_category_id: result.device_category_id,
                config_mapping: result.config_mapping,
                device_start_number: null,
                number_of_connection: result.number_of_connection,
                is_piezo:result.is_piezo
              };

            }else{

              body = {
                user_id: localStorage.getItem('user_id'),
                name: result.device_type,
                detail: result.device_detail,
                communication_type: result.communication_type,
                device_category_id: result.device_category_id,
                config_mapping: result.config_mapping,
                device_start_number: null,
                number_of_connection: null
              };
            }
            this.changeService.loader(true);
            this.service.addUserPost(this.addDeviceType, body).then(res => {
              this.changeService.loader(false);
              if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
                const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
                this.service.showError(msgErr);
              } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
                this.service.showSuccess('Device registered successfully');
                this.getDeviceTypeListing();
              } else {
                this.service.showError('Something went wrong.');
              }
            });
          }
        }
      }
    });
  }


  editInfo(obj, idx) {
    console.log("edit object: ", obj)

    const config = JSON.parse(obj.output_config);
    const output_comm = JSON.parse(obj.output_comm);

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'editNewDevicePop',
        data: { device_type: obj.name, device_detail: obj.detail, device_category_id: obj.device_category_id,config_mapping: obj.config_mapping,
          communication_type: output_comm.output,  device_start_number: config.modbus_device_no, number_of_connection: config.no_of_connection
        }}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result !== undefined) {
        if (result.type === 'editNewDevicePop') {
          if (result.data.device_type === undefined) {
            this.service.showError("Device type can't be empty.");
          } else if (result.data.device_detail === undefined) {
            this.service.showError("Device detail can't be empty.");
          } else {
            let body ={};

            if(result.data.device_category_id==2|| result.data.device_category_id==3){

              body = {
                name: result.data.device_type,
                detail: result.data.device_detail,
                communication_type:result.data.communication_type,
                device_category_id: result.data.device_category_id,
                config_mapping: result.data.config_mapping,
                device_start_number: result.data.device_start_number,
                number_of_connection: result.data.number_of_connection
              };

            }else if(result.data.device_category_id==5){

              body = {
                name: result.data.device_type,
                detail: result.data.device_detail,
                communication_type:result.data.communication_type,
                device_category_id: result.data.device_category_id,
                config_mapping: result.data.config_mapping,
                device_start_number: null,
                number_of_connection: result.data.number_of_connection
              };

            }else{

              body = {
                name: result.data.device_type,
                detail: result.data.device_detail,
                communication_type:result.data.communication_type,
                device_category_id: result.data.device_category_id,
                config_mapping: result.data.config_mapping,
                device_start_number: null,
                number_of_connection: null
              };

            }

            this.changeService.loader(true);
            this.service.putData(this.editDeviceType + "/" + obj.id, body).then(res => {
              this.changeService.loader(false);
              if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
                const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
                this.service.showError(msgErr);
              } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
                this.service.showSuccess('Device update successfully');
                this.getDeviceTypeListing();
              } else {
                this.service.showError('Something went wrong.');
              }
            });
          }
        }
      }
    });
  }



  deleteNewDeviceDialogBox(obj, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'deleteNewDeviceDailogBox',
        data: { device_type: obj.name, device_detail: obj.detail }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result.type === 'deleteNewDeviceDailogBox') {
          this.service.deleteInfo(this.deviceDeleteUrl + "/" + obj.id).then(res => {
            if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
              this.service.showSuccess('Successfully deleted.');
              this.deviceTypeList.splice(index, 1);
              if (this.deviceTypeList.length === 0) {
                this.showList = false;
                this.emptyMsg = true;
              }
            } else {
              this.service.showSuccess('Something went wrong.');
            }
          });
        }
      }
    });
  }

  showMappingConfig(obj, index){

    const outputConfig = JSON.parse(obj.output_config);
    this.router.navigate(['/energy-meter-configuration-mapping'], {
      queryParams: {
        deviceCategoryId: obj.device_category_id,
        deviceId: obj.id,
        modbusDeviceNo: outputConfig.modbus_device_no
      }
    });

  }


}
